import React, { useEffect, useRef } from 'react';
import { useState } from 'react';
import AddIcon from '@mui/icons-material/Add';

import logo from '../../assets/logo.png';
import { UserAvatar } from '@datascient/datascient-ui-library';
import AddButton from 'datascient-ui-library/src/lib/Molecules/AddButton/AddButton';
import { useNavigate } from 'react-router-dom';
import GridViewIcon from '@mui/icons-material/GridView';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import HandymanIcon from '@mui/icons-material/Handyman';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import AppRegistrationIcon from '@mui/icons-material/AppRegistration';
import { Box, Menu, MenuItem } from '@mui/material';
import { analytics } from './LoginAccount';
import zIndex from '@mui/material/styles/zIndex';
const LandingHeader = ({ selectedPage }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  // const popoverRef = useRef(null);

  const handleClosePopover = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (anchorEl && !anchorEl.contains(event.target)) {
        handleClosePopover();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [anchorEl]);
  // console.log(anchorEl);
  const handleAvatarClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  var navigate = useNavigate();
  const headerStyle = {
    position: 'sticky',
    top: '0',
    left: '0',
    right: '0',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '10px 20px',
    backgroundColor: '#0A192F', // Stitch midnight-navy
    height: '60px !important',
    zIndex: '1000',
    borderBottom: '1px solid rgba(148, 163, 184, 0.1)', // Subtle border instead of shadow
  };

  const logoStyle = {
    height: '40px',
    cursor: 'pointer',
    objectFit: 'contain'
  };

  const rightCornerStyle = {
    marginLeft: 'auto',
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'row',
  };

  const handleCreateContentClick = () => {
    localStorage.setItem('campaignId', null);
    localStorage.setItem('SelectedTemplate', '');
    localStorage.setItem('eventType', undefined);
    analytics.track('Create_campaign');
    navigate('/Studio');
  };
  // const handleTemplateClick = () => {
  //   navigate('/Template');
  // };
  // const handleDashboardClick = () => {
  //   navigate('/campaigns');
  // };
  // const handleLandingPageClick = () => {
  //   navigate('/dashboard');
  // };
  // const handleAbouBrandClicked = () => {
  //   navigate('/AboutBrand');
  // };
  // const handleMarketingPlanClicked = () => {
  //   navigate('/marketingSetup');
  // };
  const handleAdminClicked = () => {
    navigate('/AIStudio');
  };
  const handleAppsClicked = () => {
    navigate('/Apps');
  };
  const handleLogoutClick = () => {
    console.log('logoutclicked');
    localStorage.clear();

    // Navigate to the signup page (change '/signup' to your signup route)
    navigate('/login');
    setAnchorEl(null);
  };
  const handleMonitoringDashboardClicked = () => {
    navigate('/monitoringDashboard');

  };
  const handleUserRolesPermissionsClick = () => {
    navigate('/access-control');
    setAnchorEl(null);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  return (
    <Box sx={headerStyle}>
      <Box>
        <img
          src={logo}
          alt="Logo"
          style={logoStyle}
          onClick={() => {
            navigate('/AIStudio');
          }}
        />
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          marginLeft: '30px',
        }}
      >
        {/* <AddButton
          text={'Dashboard'}
          icon={<GridViewIcon style={{ height: '20px', width: '20px' }} />}
          sx={{
            fontSize: '12px !important',
            color: selectedPage === 'Dashboard' ? '#159DFF' : '#131F32',
            marginRight: '20px',
            border: 'none',
            fontWeight: '600',
            borderRadius: '8px',
          }}
          handleClick={handleLandingPageClick}
        />
        <AddButton
          text={'Campaigns'}
          icon={<LocalOfferIcon style={{ height: '20px', width: '20px' , color: selectedPage === 'Campaigns' ? '#159DFF' : '#131F32'}} />}
          sx={{
            fontSize: '12px !important',
            color: selectedPage === 'Campaigns' ? '#159DFF' : '#131F32',
            marginRight: '20px',
            border: 'none',
            fontWeight: '600',
            borderRadius: '8px',
          }}
          // handleClick={handleCreateContentClick}
          handleClick={handleDashboardClick}
        />
        <AddButton
          text={'Templates'}
          icon={<NoteAddIcon style={{ height: '20px', width: '20px' }} />}
          sx={{
            fontSize: '12px !important',
            color: selectedPage === 'Templates' ? '#159DFF' : '#131F32',
            marginRight: '20px',
            border: 'none',
            fontWeight: '600',
            borderRadius: '8px',
          }}
          handleClick={handleTemplateClick}
        />
        <AddButton
          text={'Brand Toolkit'}
          icon={<HandymanIcon style={{ height: '20px', width: '20px' }} />}
          sx={{
            fontSize: '12px !important',
            color: '#131F32',
            marginRight: '20px',
            border: 'none',
            fontWeight: '600',
            borderRadius: '8px',
          }}
          handleClick={handleAbouBrandClicked}
        />
        <AddButton
          text={'Marketing Setup'}
          icon={
            <AppRegistrationIcon style={{ height: '20px', width: '20px' }} />
          }
          sx={{
            fontSize: '12px !important',
            color: '#131F32',
            marginRight: '20px',
            border: 'none',
            fontWeight: '600',
            borderRadius: '8px',
          }}
          handleClick={handleMarketingPlanClicked}
        /> */}
        <AddButton
          text={'AI Studio'}
          icon={
            <AdminPanelSettingsIcon style={{ height: '20px', width: '20px' }} />
          }
          sx={{
            fontSize: '12px !important',
            color: selectedPage === 'AdminPanel' ? '#FFDE59' : '#94A3B8',
            marginRight: '20px',
            border: 'none',
            fontWeight: '600',
            borderRadius: '8px',
          }}
          handleClick={handleAdminClicked}
        />

        <AddButton
          text={'Operators'}
          icon={<NoteAddIcon style={{ height: '20px', width: '20px' }} />}
          sx={{
            fontSize: '12px !important',
            color: selectedPage === 'Apps' ? '#FFDE59' : '#94A3B8',
            marginRight: '20px',
            border: 'none',
            fontWeight: '600',
            borderRadius: '8px',
          }}
          handleClick={handleAppsClicked}
        />
        <AddButton
          text={'Operations'}
          icon={<GridViewIcon style={{ height: '20px', width: '20px' }} />}
          sx={{
            fontSize: '12px !important',
            color: selectedPage === 'monitoringDashboard' ? '#FFDE59' : '#94A3B8',
            marginRight: '20px',
            border: 'none',
            fontWeight: '600',
            borderRadius: '8px',
          }}
          handleClick={handleMonitoringDashboardClicked}
        />


      </Box>
      <Box sx={rightCornerStyle}>
        {/* <AddButton
          text={'Create Content'}
          icon={<AddIcon style={{ height: '20px', width: '20px' }} />}
          sx={{
            fontSize: '12px !important',
            color: '#131F32',
            marginRight: '10px',
            border: 'none',
            fontWeight: '600',
            borderRadius: '8px',
          }}
          handleClick={handleCreateContentClick}
        /> */}
      </Box>

      <div onClick={handleAvatarClick}>
        <UserAvatar text={localStorage.getItem('org_id') || 'O'} />
      </div>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        PaperProps={{
          sx: {
            borderRadius: '12px',
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
            border: '1px solid #E5E7EB',
            minWidth: '200px',
            mt: 1
          }
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <MenuItem
          disabled
          sx={{
            fontSize: '0.75rem',
            fontWeight: 600,
            color: '#6B7280',
            textAlign: 'left',
            px: 2.5,
            py: 1.5,
            borderBottom: '1px solid #F3F4F6',
            backgroundColor: '#F9FAFB'
          }}
        >
          {localStorage.getItem('org_id')}
        </MenuItem>
        <MenuItem
          onClick={handleUserRolesPermissionsClick}
          sx={{
            textAlign: 'left',
            fontSize: '0.8rem',
            fontWeight: 500,
            color: '#1F2937',
            px: 2.5,
            py: 1.5,
            transition: 'all 0.2s ease',
            '&:hover': {
              backgroundColor: 'rgba(156, 39, 176, 0.08)',
              color: '#9C27B0'
            }
          }}
        >
          User Roles & Permissions
        </MenuItem>
        <MenuItem
          onClick={handleLogoutClick}
          sx={{
            textAlign: 'left',
            fontSize: '0.8rem',
            fontWeight: 500,
            color: '#dc2626',
            px: 2.5,
            py: 1.5,
            transition: 'all 0.2s ease',
            '&:hover': {
              backgroundColor: 'rgba(220, 38, 38, 0.08)',
              color: '#b91c1c'
            }
          }}
        >
          Logout
        </MenuItem>
      </Menu>
    </Box>
  );
};

export default LandingHeader;
